import React from 'react';
import styled from 'styled-components';
import { MenuCategory as MenuCategoryType, Language } from '../types';
import { theme } from '../styles/theme';
import MenuItem from './MenuItem';

const CategoryContainer = styled.section`
  margin-bottom: ${theme.spacing(4)};
`;

const CategoryHeader = styled.h2`
  font-family: ${theme.typography.fontFamily};
  font-size: ${theme.typography.h2.fontSize};
  font-weight: ${theme.typography.h2.fontWeight};
  color: ${theme.colors.primary};
  margin: 0 0 ${theme.spacing(3)} 0;
  padding: ${theme.spacing(2)} 0 ${theme.spacing(1)} 0;
  position: sticky;
  top: 0;
  background: ${theme.colors.background};
  z-index: 10;
  border-bottom: 2px solid ${theme.colors.primary};

  @media (max-width: ${theme.breakpoints.mobile}) {
    font-size: ${theme.typography.h3.fontSize};
    margin-bottom: ${theme.spacing(2)};
    padding: ${theme.spacing(1)} 0;
  }
`;

const ItemsContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

interface MenuCategoryProps {
  category: MenuCategoryType;
  language: Language;
}

const MenuCategory: React.FC<MenuCategoryProps> = ({ category, language }) => {
  return (
    <CategoryContainer id={category.id}>
      <CategoryHeader>{category.name[language]}</CategoryHeader>
      <ItemsContainer>
        {category.items.map(item => (
          <MenuItem key={item.id} item={item} language={language} />
        ))}
      </ItemsContainer>
    </CategoryContainer>
  );
};

export default MenuCategory;